var _rect, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCFlatToilet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#666",
  rx: 1.994
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.211 1.579h1.578V22.42h-1.578z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  transform: "translate(15.319 4.204)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.578,
  cy: 1.579,
  rx: 1.578,
  ry: 1.579,
  transform: "translate(1.578)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.735 3.948H1.578A1.58 1.58 0 0 0 0 5.527v4.738h.789v-3.9h.789v3.109l-.789 5.528h1.529l.838-5.528.839 5.528h1.529l-.789-5.528V6.367h.789v3.9h.789V5.529a1.58 1.58 0 0 0-1.578-1.581"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  transform: "translate(2.367 4.204)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.578,
  cy: 1.579,
  rx: 1.578,
  ry: 1.579,
  transform: "translate(1.578)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.735 3.948H1.578A1.58 1.58 0 0 0 0 5.527v4.738h.789v-3.9h.789v2.319L.789 13.57h1.578v1.431h1.578V13.57h1.578l-.789-4.886V6.367h.789v3.9h.789V5.529a1.58 1.58 0 0 0-1.577-1.581"
}))));
export { SvgCFlatToilet as ReactComponent };